// extracted by mini-css-extract-plugin
export var blue = "Carousel-module--blue--4e8de";
export var carousel = "Carousel-module--carousel--49327";
export var collapse = "Carousel-module--collapse--a1dd1";
export var content = "Carousel-module--content--14438";
export var cta = "Carousel-module--cta--f24b0";
export var description = "Carousel-module--description--dde91";
export var eyebrowText = "Carousel-module--eyebrow-text--7804b";
export var flipped = "Carousel-module--flipped--5e027";
export var green = "Carousel-module--green--94e2b";
export var heading = "Carousel-module--heading--d0ce6";
export var image = "Carousel-module--image--421cd";
export var item = "Carousel-module--item--51287";
export var open = "Carousel-module--open--a897b";
export var pink = "Carousel-module--pink--d0e8c";
export var purple = "Carousel-module--purple--659ff";
export var showProgress = "Carousel-module--show-progress--455cb";